import {
    useState,
    forwardRef,
    useImperativeHandle,
    useRef,
} from "react"
import DateSelector from "../DateSelector"
import TextInput from "../TextInput"

// for first name or last name
const nameValidator = (val) => /^[\p{L} '-]{2,50}$/u.test(val.trim())
const passportValidator = (val) => /^(?=(?:.*[A-Za-z0-9]){3,}).*$/.test(val.trim())

const PassportInput = forwardRef(({ title, data, readOnly }, ref) => {
    const [error, setError] = useState(false)

    const givenNameRef = useRef()
    const surNameRef = useRef()
    const passportNumberRef = useRef()
    const issuingCountryRef = useRef()
    const issueDateRef = useRef()
    const expiryDateRef = useRef()

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            const givenNameData = givenNameRef.current.validateAndGetData()
            const surNameData = surNameRef.current.validateAndGetData()
            const passportNumberData = passportNumberRef.current.validateAndGetData()
            const issuingCountryData = issuingCountryRef.current.validateAndGetData()
            const issueDateData = issueDateRef.current.validateAndGetData()
            const expiryDateData = expiryDateRef.current.validateAndGetData()

            // Combine validity of main name fields
            let validity =
                givenNameData.isValid &&
                surNameData.isValid &&
                passportNumberData.isValid &&
                issuingCountryData.isValid &&
                issueDateData.isValid &&
                expiryDateData.isValid

            const value = {
                givenName: givenNameData.value,
                surName: surNameData.value,
                passportNumber: passportNumberData.value,
                issuingCountry: issuingCountryData.value,
                issueDate: issueDateData.value,
                expiryDate: expiryDateData.value,
            }

            setError(!validity)
            return { isValid: validity, value }
        },
    }))

    return (
        <div className="my-4">
            <label className="block text-sm font-medium text-gray-700 mb-4">{title}</label>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <TextInput
                    title="Given Names"
                    ref={givenNameRef}
                    data={data?.givenName}
                    validator={nameValidator}
                    isMandatory={true}
                    disabled={readOnly}
                />

                <TextInput
                    title="Surname"
                    ref={surNameRef}
                    data={data?.surName}
                    validator={nameValidator}
                    isMandatory={true}
                    disabled={readOnly}
                />

                <TextInput
                    title="Passport Number"
                    ref={passportNumberRef}
                    data={data?.passportNumber}
                    validator={passportValidator}
                    isMandatory={true}
                    disabled={readOnly}
                />

                <TextInput
                    title="Issuing Country"
                    ref={issuingCountryRef}
                    data={data?.issuingCountry}
                    validator={nameValidator}
                    isMandatory={true}
                    disabled={readOnly}
                />

                <DateSelector
                    title="Issue Date"
                    ref={issueDateRef}
                    data={data?.issueDate}
                    readOnly={readOnly}
                />

                <DateSelector
                    title="Expiry Date"
                    ref={expiryDateRef}
                    data={data?.expiryDate}
                    readOnly={readOnly}
                />

            </div>

            {/* Error Message */}
            {error && (
                <p className="mt-2 text-sm text-red-600">
                </p>
            )}
        </div>
    )
})

export default PassportInput
